module.exports = __webpack_public_path__ + "assets/img/ic-intro-cake.103df6b0.png";